<template>
  <InnerView>
    <template #header>
      <div class="space-y-2">
        <div class="flex items-center space-x-1">
          <BaseButton
            iconOnly
            variant="tertiary"
            icon="chevron-left"
            @click="goBack"
            class="!text-primary-contrast"
          />
          <h1
            class="flex items-center font-bold text-primary-contrast tracking-wide transition-all pl-1 text-xl"
          >
            {{ $t('settings.title') }}
          </h1>
        </div>
        <h2 class="transition-all text-primary-contrast pl-1 text-sm">V{{ version }}</h2>
      </div>
    </template>
    <settings-view
      class="h-full pt-6 px-4.5"
      :locale="locale"
      :options="settingsOptions"
      :width="width"
      @update:locale="configStore.setLocale($event)"
      @update:position="configStore.setPosition($event)"
      @refresh="refresh"
      @logout="configStore.logout()"
    ></settings-view>
  </InnerView>
</template>

<script setup lang="ts">
import { version } from '../../../package.json'
import InnerView from '@commons/components/Layout/InnerView.vue'
import useApp from '@commons/composables/useApp'
import { useAdminStore } from '@getmayday/vue-modules'

const router = useRouter()
const configStore = useConfigStore()
const { width, locale } = storeToRefs(configStore)

const { refresh } = useApp()

const adminStore = useAdminStore()
const { hasCompanyBrainAgentsPreference, hasAdminAccess, hasUserPreference } =
  storeToRefs(adminStore)

const settingsOptions = {
  language: true,
  displayFullTitle: true,
  contentFontSize: true,
  appActions: true,
  appShortcuts: true,
  copyArticleShortcut: true,
  copyGuideShortcut: true,
  geniusTestMode: hasAdminAccess.value && hasCompanyBrainAgentsPreference.value
}

const goBack = () => {
  router.go(-1)
}

watch(
  () => hasUserPreference.value('GENIUS_TEST_MODE'),
  (newValue, oldValue) => {
    if (newValue !== oldValue && !newValue) {
      configStore.setGeniusTestMode(false)
    }
  }
)
</script>
